import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import featureFlags from 'shared/lib/featureFlags';
import { Checkbox } from 'shared/components/Form';
import styles from './useFeatureFlags.module.scss';

const useFeatureFlags = () => {
  const [visible, setVisible] = useState(featureFlags.dialog);
  const [state, setState] = useState({
    logger: featureFlags.logger,
    i18n: featureFlags.i18n,
    inactiveJobApplication: featureFlags.inactiveJobApplication,
    htmlModule: featureFlags.htmlModule,
    anonymousProfiles: featureFlags.anonymousProfiles,
  });
  const toggleVisibility = () => setVisible(prev => !prev);
  const [showParts, setShowParts] = useState(false);
  const toggleParts = () => setShowParts(prev => !prev);

  const reduxSize = useSelector(reduxState => Math.round((JSON.stringify(reduxState).length / 1024) * 100) / 100);
  const reduxPartsSize = useSelector(reduxState => Object.entries(reduxState).map(([key, part]) => [key, Math.round((JSON.stringify(part || {}).length / 1024) * 100) / 100]).sort((a, b) => a[0].localeCompare(b[0])));

  const onCloseClick = (event) => {
    event.preventDefault();
    featureFlags.setFlag('dialog', false);
    toggleVisibility();
  };

  const onResetAllClick = (event) => {
    event.preventDefault();
    featureFlags.resetAll();
    toggleVisibility();
    setTimeout(() => window.location.reload());
  };

  const onClickHandler = (event) => {
    event.persist();
    if (!event.altKey) {
      return;
    }

    featureFlags.setFlag('dialog', !visible);
    toggleVisibility();
  };

  const onFlagChange = ({ target: { name, checked } }) => {
    setState(prev => ({ ...prev, [name]: checked }));
    featureFlags.setFlag(name, checked);
    setTimeout(() => window.location.reload());
  };

  const getComponent = () => {
    if (!visible) {
      return null;
    }

    return (
      <div className={styles.dialog}>
        <a href="" className={styles.close} onClick={onCloseClick}>
          <i className="la la-window-close" />
        </a>
        <div>
          Layout:
          <span className={cn(styles.bp, styles.xs)}>XS</span>
          <span className={cn(styles.bp, styles.sm)}>SM</span>
          <span className={cn(styles.bp, styles.md)}>MD</span>
          <span className={cn(styles.bp, styles.lg)}>LG</span>
          <span className={cn(styles.bp, styles.xl)}>XL</span>
        </div>
        <div>
          <span style={{ cursor: 'pointer' }} onClick={toggleParts}>Redux store size: {reduxSize} kB</span>
          <ul style={{ display: showParts ? 'block' : 'none' }}>
            {reduxPartsSize.map(([part, size]) => (
              <li key={part}>{part}: {size} kB</li>
            ))}
          </ul>
        </div>
        <div>
          <Checkbox name="i18n" value={state.i18n} onChange={onFlagChange} label="i18n debug" />
        </div>
        <div>
          <Checkbox name="logger" value={state.logger} onChange={onFlagChange} label="logger" />
        </div>
        <div>
          <Checkbox name="inactiveJobApplication" value={state.inactiveJobApplication} onChange={onFlagChange} label="inactive job applications" />
        </div>
        <div>
          <Checkbox name="htmlModule" value={state.htmlModule} onChange={onFlagChange} label="HTML module" />
        </div>
        <div>
          <Checkbox name="anonymousProfiles" value={state.anonymousProfiles} onChange={onFlagChange} label="anonymous profiles" />
        </div>
        <div>
          <a href="" className={styles.reset} onClick={onResetAllClick}>
            reset all
          </a>
        </div>
      </div>
    );
  };

  return {
    onClickHandler,
    featureFlagsComponent: getComponent()
  };
};

export default useFeatureFlags;
